var app = angular.module('directives.setFocus', []);

app.directive('setFocus', ['$timeout' ,function ($timeout) {
    return {
        restrict: 'A',
        link: function($rootScope, element, attrs) {

            var delay= 300;

            // set focus on broadcast
            $rootScope.$on(attrs.setFocus, function(e) {
                $timeout(function(){
                    element[0].focus();
                }, delay);
            });

            // fix for default focus on iOS. Does not show keyboard
            element.on('touchstart', function(event) {
                element[0].blur();
            });
        }
    };
}]);


module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/setFocus/index.js
 ** module id = 224
 ** module chunks = 1
 **/